import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const CATEGORY_COLORS = {
  strength: "bg-primary/10 text-primary",
  cardio: "bg-chart-3/20 text-chart-3",
  yoga: "bg-accent/20 text-accent",
  mobility: "bg-chart-4/20 text-chart-4",
  core: "bg-chart-5/20 text-chart-5",
};

export default function ExerciseLibrary() {
  const [exercises, setExercises] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/fitness/exercises");
      setExercises(data);
    })();
  }, []);

  const filtered = exercises.filter(
    (x) =>
      !query ||
      x.name.toLowerCase().includes(query.toLowerCase()) ||
      x.category.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="px-4 md:px-8 py-8 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-2">Fitness</div>
          <h1 className="font-display text-4xl">Exercise library</h1>
          <p className="text-muted-foreground text-sm mt-1">
            {exercises.length} exercises · Categorised by movement pattern
          </p>
        </div>
        <div className="relative">
          <Search className="h-4 w-4 absolute left-3 top-3 text-muted-foreground" />
          <Input placeholder="Search exercises" value={query} onChange={(e) => setQuery(e.target.value)} className="pl-9 w-72" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map((x) => (
          <div key={x.id} className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
            <div className="flex items-start justify-between">
              <div className="font-display text-xl leading-tight">{x.name}</div>
              <span className={"text-[10px] uppercase tracking-[0.18em] rounded-full px-2 py-0.5 " + (CATEGORY_COLORS[x.category] || "bg-muted text-muted-foreground")}>
                {x.category}
              </span>
            </div>
            <div className="mt-3 text-sm text-muted-foreground">
              {x.muscle_groups?.join(" · ") || "—"}
            </div>
            {x.equipment && (
              <div className="mt-2 text-xs text-muted-foreground">Equipment: {x.equipment}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
